var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WaitingForDeliveryViewPage.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-2ff1cb53!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WaitingForDeliveryViewPage.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/WaitingForDeliveryViewPage.vue
// module id = 313
// module chunks = 1